module.exports = __webpack_public_path__ + "img/oneList1_new.075173d5.png";